import React, { useEffect, useState, useRef } from 'react';
import { reduce } from 'lodash';
import { get } from '../../../common/httpService';
import { getProductsBySlugs as getBySlug } from '../../../services/product/productService';

import ProductSlider from './ProductSlider.jsx';

function ProductSlugFacade({ products }) {
    const [productsData, setProductsData] = useState([]);

    const unmounted = useRef(false);
    useEffect(() => {
        return () => {
            unmounted.current = true;
        };
    }, []);

    async function getProductsOnOffer(unmounted) {
        const data = await get({
            url: `ProductBrowse/GetProductsOnOffer?pageSize=10&availableOnly=true`,
        });

        if (!unmounted.current) {
            setProductsData(data.products);
        }
    }

    async function getProductsBySlugs(array, unmounted) {
        const data = await getBySlug(array);
        if (!unmounted.current) {
            setProductsData(data);
        }
    }

    useEffect(() => {
        try {
            if (products) {
                let res = reduce(
                    products,
                    (acc, p) => {
                        acc.push(p.slug);
                        return acc;
                    },
                    []
                );
                getProductsBySlugs(res, unmounted);
            } else {
                getProductsOnOffer(unmounted);
            }
        } catch (error) {
            console.error('Error in ProductSlugFacade', error);
            if (!unmounted.current) {
                setProductsData([]);
            }
        }
    }, [productsData.length]);

    {
        if (productsData && productsData.length > 0) {
            return <ProductSlider products={productsData} />;
        }
        return <></>;
    }
}

export default ProductSlugFacade;
